export default {
  choose_preferred_wallet: "Choose your preferred wallet",
  connect_mobile_wallet: "Connect to Mobile Wallet",
  scan_qrcode_with_wallet: "Scan QR code with a WalletConnect-compatible wallet",
  return_to_mobile_options: "Return to mobile wallet options",
  view_qrcode_option: "View QR code",
  connect: "Connect",
};
